import React from 'react';
import { FadeIn } from './Shared';
import { Check, Calculator, Ghost, Clock, Beer, Brain, Siren } from 'lucide-react';
export function Deliverables() {
  const items = [{
    icon: <Calculator className="text-toxic" size={32} data-id="element-13" />,
    title: 'The 21-Day Tapering Schedule',
    desc: 'The exact milligram-reduction math to go from 50mg to 0mg.'
  }, {
    icon: <Ghost className="text-toxic" size={32} data-id="element-14" />,
    title: 'The Hand-to-Mouth Ghost Phase',
    desc: "Tactical tools to kill the physical 'fidget' addiction."
  }, {
    icon: <Clock className="text-toxic" size={32} data-id="element-15" />,
    title: 'The 72-Hour Final Peak',
    desc: 'A day-by-day survival guide for the final nicotine exit.'
  }, {
    icon: <Beer className="text-toxic" size={32} data-id="element-16" />,
    title: 'The Pub Survival Guide',
    desc: 'How to drink with mates in a beer garden without reaching for their vape.'
  }, {
    icon: <Brain className="text-toxic" size={32} data-id="element-17" />,
    title: 'The Dopamine Swap List',
    desc: 'Natural ways to keep your mood stable while your brain recalibrates.'
  }, {
    icon: <Siren className="text-toxic" size={32} data-id="element-18" />,
    title: 'The Emergency Protocol',
    desc: 'What to do in the first 60 seconds of a massive craving.'
  }];
  return <section className="py-24 px-4 bg-neutral-950 relative border-t border-neutral-900" data-id="element-19">
      <div className="max-w-6xl mx-auto" data-id="element-20">
        <FadeIn data-id="element-21">
          <div className="text-center mb-16" data-id="element-22">
            <h2 className="text-4xl md:text-5xl font-black uppercase mb-6" data-id="element-23">
              Inside The <span className="text-toxic" data-id="element-24">Blueprint</span>
            </h2>
            <p className="text-xl text-neutral-400" data-id="element-25">
              Everything you need to break the cycle, step-by-step.
            </p>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-26">
          {items.map((item, i) => <FadeIn key={i} delay={i * 0.1} data-id="element-27">
              <div className="bg-[#111] border border-neutral-800 p-8 h-full hover:border-toxic/50 transition-colors group" data-id="element-28">
                <div className="mb-6 bg-neutral-900 w-16 h-16 flex items-center justify-center rounded-sm group-hover:scale-110 transition-transform" data-id="element-29">
                  {item.icon}
                </div>
                <h3 className="text-xl font-display font-bold text-white mb-3" data-id="element-30">
                  {item.title}
                </h3>
                <p className="text-neutral-400 leading-relaxed" data-id="element-31">{item.desc}</p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}